import { RequestStatus } from '@/pages/team/teamMember/requests/RequestsTable.types';
import { ApprovalState } from '@/services/gql/graphql.generated';

export const getRequestStatus = (approval?: ApprovalState | null): RequestStatus => {
  switch (approval) {
    case ApprovalState.Requested:
      return RequestStatus.Pending;
    case ApprovalState.Approved:
    case ApprovalState.Applied:
      return RequestStatus.Approved;
    case ApprovalState.Rejected:
      return RequestStatus.Denied;
    case ApprovalState.CancelledByManager:
      return RequestStatus.CancelledByManager;
    case ApprovalState.Cancelled:
    case ApprovalState.Superseded:
    default:
      return RequestStatus.CancelledByEmployee;
  }
};
